import { cities as sharedCities } from 'discontract-js-shared';

export const currencies = {
  EUR: {
    symbol: '€',
  },
  PLN: {
    symbol: 'zł',
  },
};

export const countries = {
  LT: {
    currency: 'EUR',
  },
  PL: {
    currency: 'PLN',
  },
};

export const cities = sharedCities.reduce((prev, next) => {
  prev[next.code] = next;
  return prev;
}, {});
